module.exports = __webpack_public_path__ + "media/images/bet__correctMarker@2x-09882558019cd7a0e7cc66018b42d7b1.png";